import classNames from "classnames/bind";
import styles from "../../styles/label.module.scss";
const css = classNames.bind(styles);

export const Label = ({ children, className, text, required }) => {
  return (
    <div className={css({ [className]: className, labelContainer: true })}>
      {children || text}
      {required ? <span className={styles.required}>*</span> : null}
    </div>
  );
};
